import { createSelector } from 'reselect';
import {
	getPlanScenarios,
	isMultiScenarioEnabled,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/plan';
import type { MapStateToProps } from '@atlassian/jira-portfolio-3-portfolio/src/common/types/redux';
import { functionWithFFRedux } from '@atlassian/jira-react-redux';
import type { StateProps } from './types';

const mapStateToPropsOld: MapStateToProps<StateProps> = (state) => ({
	isMultiScenarioEnabled: isMultiScenarioEnabled(state) ?? false,
	planScenarios: getPlanScenarios(state),
});

const getPlanScenariosMemoized = () => createSelector(getPlanScenarios, (res) => res);
const mapStateToPropsFactory: () => MapStateToProps<StateProps> = () => {
	const getPlanScenariosInstance = getPlanScenariosMemoized();
	return (state) => ({
		isMultiScenarioEnabled: isMultiScenarioEnabled(state) ?? false,
		planScenarios: getPlanScenariosInstance(state),
	});
};
const mapStateToProps = // @ts-expect-error - TS2345 - Target signature provides too few arguments. Expected 1 or more, but got 0.
	functionWithFFRedux(mapStateToPropsFactory, mapStateToPropsOld);

export default mapStateToProps;
